"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateConditions = exports.generateOptions = exports.generateQuestionDataRandom = exports.generateQuestionData = exports.generateQuestionType = exports.generateQuestionTypeInsideMatrix = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const FIELDS_ON_LIST = [
    types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST,
    types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST,
    types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST,
];
const generateOperator = () => {
    const operator = [
        types_1.CONDITION_OPERATOR.EQUAL,
        types_1.CONDITION_OPERATOR.DIFFERENT,
        types_1.CONDITION_OPERATOR.GREATER_THAN,
        types_1.CONDITION_OPERATOR.LESS_THAN,
        types_1.CONDITION_OPERATOR.OR,
        types_1.CONDITION_OPERATOR.AND,
        types_1.CONDITION_OPERATOR.GREATER_OR_EQUAL_TO,
        types_1.CONDITION_OPERATOR.LESS_OR_EQUAL_TO,
    ];
    const randomNumber = Math.floor(Math.random() * operator.length);
    return operator[randomNumber];
};
/**
 * Generates a random question type that can go inside a matrix. If "onListQuestions"
 * is set to true, generates all type of questions (that can be in a matrix).
 * Otherwise, it generates only the questions that are not linked to a list
 * @param onListQuestions
 * @returns
 */
const generateQuestionTypeInsideMatrix = (onListQuestions = false) => {
    let randomNumber;
    const questionTypeArray = [];
    Object.values(types_1.CUSTOM_FIELD_TYPE)
        .filter((t) => onListQuestions || !FIELDS_ON_LIST.includes(t))
        .forEach((t) => {
        if (![
            types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST,
            types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST,
        ].includes(t)) {
            questionTypeArray.push(t);
        }
    });
    randomNumber = Math.floor(Math.random() * questionTypeArray.length);
    return questionTypeArray[randomNumber];
};
exports.generateQuestionTypeInsideMatrix = generateQuestionTypeInsideMatrix;
/**
 * Generates a random question type. If "onListQuestions" is set to true, generates all type of questions.
 * Otherwise, it generates only the questions that are not linked to a list
 * @param onListQuestions
 * @returns
 */
const generateQuestionType = (onListQuestions = false) => {
    let randomNumber;
    const questionTypeArray = [];
    Object.values(types_1.CUSTOM_FIELD_TYPE)
        .filter((t) => t !== types_1.CUSTOM_FIELD_TYPE.GEO_DELIMITATION)
        .filter((t) => onListQuestions || !FIELDS_ON_LIST.includes(t))
        .forEach((t) => {
        questionTypeArray.push(t);
    });
    randomNumber = Math.floor(Math.random() * questionTypeArray.length);
    return questionTypeArray[randomNumber];
};
exports.generateQuestionType = generateQuestionType;
const generateSearchFields = () => {
    let result = [];
    const randomNb = en_1.faker.number.int({ min: 2, max: 5 });
    for (let i = 0; i < randomNb; i++) {
        result.push(en_1.faker.lorem.word());
    }
    return result;
};
const addValidationProperties = (question) => {
    if (en_1.faker.datatype.boolean()) {
        question.validation = en_1.faker.lorem.word();
        if (en_1.faker.datatype.boolean()) {
            question.validation_text = en_1.faker.lorem.words();
        }
    }
    return question;
};
const addConditionProperties = (question) => {
    if (en_1.faker.datatype.boolean()) {
        question["conditions"] = (0, exports.generateConditions)();
    }
    return question;
};
const addOptionsProperties = (question) => {
    question.options = generateOptionsRandom(2, 5);
    return question;
};
const generateQuestionData = (questionType) => {
    return (0, exports.generateQuestionDataRandom)(en_1.faker.datatype.boolean(), false, questionType);
};
exports.generateQuestionData = generateQuestionData;
const generateQuestionDataRandom = (forceRequired, isInMatrix, forcedType, onListQuestions = false) => {
    let type;
    if (forcedType) {
        type = forcedType;
    }
    else {
        if (isInMatrix) {
            type = (0, exports.generateQuestionTypeInsideMatrix)(onListQuestions);
        }
        else {
            type = (0, exports.generateQuestionType)(onListQuestions);
        }
    }
    // fill mandatory fields for each question type
    let returnObject = {
        type: type,
        tag: (0, tools_1.IDSource)(),
        question_text: en_1.faker.lorem.words(),
        required: forceRequired ? true : en_1.faker.datatype.boolean(),
    };
    // fill randomly non-mandatory fields for each question type
    if (en_1.faker.datatype.boolean()) {
        returnObject["description"] = en_1.faker.lorem.words();
    }
    returnObject = addConditionProperties(returnObject);
    switch (type) {
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_TEXT:
        case types_1.CUSTOM_FIELD_TYPE.TEXT: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.STRING;
            returnObject = addValidationProperties(returnObject);
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_INTEGER:
        case types_1.CUSTOM_FIELD_TYPE.INTEGER: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.INTEGER;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_DECIMAL:
        case types_1.CUSTOM_FIELD_TYPE.DECIMAL: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.FLOAT;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.BOOLEAN;
            returnObject = addValidationProperties(returnObject);
            returnObject = addOptionsProperties(returnObject);
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.BOOLEAN;
            returnObject = addValidationProperties(returnObject);
            returnObject = addOptionsProperties(returnObject);
            if (en_1.faker.datatype.boolean()) {
                returnObject["number_of_options"] = en_1.faker.number.int(10);
            }
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.SIGNATURE:
        case types_1.CUSTOM_FIELD_TYPE.PICTURE: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.STRING;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.GPS: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.STRING;
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.BARCODE_SCANNER: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.STRING;
            returnObject = addValidationProperties(returnObject);
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.BOOLEAN; // TODO check that
            returnObject["list_id"] = (0, tools_1.IDSource)();
            returnObject["search_fields"] = generateSearchFields();
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.COMPUTE: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.BOOLEAN; // TODO check that
            returnObject["operations"] = [];
            break;
        }
        case types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.BOOLEAN;
            returnObject["list_id"] = (0, tools_1.IDSource)();
            returnObject["matrix"] = generateMatrixOnList(forceRequired);
            break;
        }
        default: {
            returnObject["column_type"] = types_1.COLUMN_TYPE.STRING;
            break;
        }
    }
    return returnObject;
};
exports.generateQuestionDataRandom = generateQuestionDataRandom;
const generateOptions = () => {
    return generateOptionsRandom(2, 5);
};
exports.generateOptions = generateOptions;
const generateOptionsRandom = (min, max) => {
    const options = [];
    const randomNb = en_1.faker.number.int({ min, max });
    for (let i = 0; i < randomNb; i++) {
        options.push({
            key: (0, tools_1.IDSource)(),
            value: en_1.faker.lorem.words(),
        });
    }
    return options;
};
const generateConditionArgument = () => {
    const valueType = en_1.faker.datatype.boolean() ? "NUMBER" : "STRING";
    let argument = {
        type: valueType,
    };
    if (en_1.faker.number.int(2) == 0) {
        // value
        argument.value =
            valueType == "NUMBER"
                ? en_1.faker.number.int(10).toString()
                : en_1.faker.lorem.word();
    }
    else if (en_1.faker.datatype.boolean()) {
        // tag
        argument.tag = (0, tools_1.IDSource)();
        if (en_1.faker.datatype.boolean()) {
            argument.param = en_1.faker.lorem.word();
        }
    }
    else {
        // condition_id
        argument.condition_id = en_1.faker.number.int(5);
    }
    return argument;
};
const generateConditions = () => {
    let conditions = [];
    const randomNb = en_1.faker.number.int(5);
    for (let i = 0; i < randomNb; i++) {
        conditions.push({
            id: i,
            priority: i,
            first: generateConditionArgument(),
            second: generateConditionArgument(),
            operator: generateOperator(),
        });
    }
    return conditions;
};
exports.generateConditions = generateConditions;
const generateMatrixOnList = (forceRequired) => {
    let title_section_attributes = [];
    const randomNb1 = en_1.faker.number.int({ min: 2, max: 5 });
    for (let i = 0; i < randomNb1; i++) {
        title_section_attributes.push(en_1.faker.lorem.word());
    }
    let title_card_attributes = [];
    const randomNb2 = en_1.faker.number.int({ min: 2, max: 5 });
    for (let i = 0; i < randomNb2; i++) {
        title_card_attributes.push(en_1.faker.lorem.words());
    }
    const questions = [];
    let nbQuestion = en_1.faker.number.int({
        min: 2,
        max: 5,
    });
    for (let i = 0; i < nbQuestion; i++) {
        questions.push((0, exports.generateQuestionDataRandom)(false, false, undefined));
    }
    return {
        typed_questions: questions,
    };
};
